import APIError from '../APIError';
class Unauthorized extends APIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        const status = 401;
        super(status, ...args);
    }
}
export default Unauthorized;
